import { Button } from "@mui/material";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import React from "react";
import * as XLSX from "xlsx";

function DownloadButtonWithMultiTabs({
  data,
  label = "Report",
  buttonLabel = "Download CSV",
}) {
  const downloaddataAsXlsx = () => {
    const workbook = XLSX.utils.book_new();

    Object.entries(data).forEach(([groupName, data]) => {
      if (!Array.isArray(data) || data.length === 0) {
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data);

      const sheetName = formatSheetName(groupName);

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        sheetName.substring(0, 31),
      );
    });

    if (workbook.SheetNames.length === 0) {
      console.error("No data available to export.");
      return;
    }

    XLSX.writeFile(workbook, `${label}.xlsx`);
  };

  const formatSheetName = (name) => {
    return (
      name
        .replace(/^dataBy/i, "")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .trim() || "Data"
    );
  };

  return (
    <Button
      onClick={downloaddataAsXlsx}
      variant="outlined"
      color="success"
      size={"small"}
      sx={{
        float: "right",
      }}
      startIcon={<UploadFileOutlinedIcon fontSize="small" />}
    >
      {buttonLabel}
    </Button>
  );
}

export default DownloadButtonWithMultiTabs;
